module.exports = __webpack_public_path__ + "svg/aries.svg?ac6faec37ab1e057d607796dbe07cbc5";